import React, { Fragment, useContext, useEffect, useState } from "react";
import { post } from 'axios';
import { map } from "jquery";

// Provider
import { AppContext } from "../../../../../components/AppProvider";

import { openLayerFn, closeLayerFn } from "../../../../Layout";

// Utils
import { _O } from "../../../../../modules/utils";

// Temp Images
import _T_MEAL from "../../../../../resources/images/user/user_meal_photo01.jpg";
import { userHabit } from "../../../../../modules/utils/UserHabit";
import { SectionTitle } from "../List";

export const ListLayer = (props) => {
  const {
    checkedAll,
    contentsList,
    settingSeqNo,
    setSeqNo,
    setMemo,
    setTargetDate,
    setDisplayMod,
  } = props;

  const openMemoPopup = (seqNo, memo) => {
    setSeqNo(seqNo);
    setMemo(memo);
    openLayerFn($(".memo-layer"));
    $("#memoPopupValue").val(memo);
  };

  useEffect(() => {
    //식단 이미지 클릭 (레이어 열기)
    $("a.btn-foodmenu").click(function () {
      openLayerFn($(".foodmenu-photo-layer"));
    });
    //식단 레이어 닫기
    $(".foodmenu-photo-layer .tbns-area a").click(function () {
      closeLayerFn($(".foodmenu-photo-layer"));
    });
    //메모 레이어 닫기(취소, 확인 모두)
    $(".memo-layer .tbns-area a").click(function () {
      closeLayerFn($(".memo-layer"));
    });
    //선택삭제 버튼 클릭(삭제 확인 레이어 열기)
    $(".btn-check-delete").click(function () {
      openLayerFn($(".delete-confirm-layer"));
    });
    //삭제 확인 레이어 닫기
    $(".delete-confirm-layer .tbns-area a").click(function () {
      closeLayerFn($(".delete-confirm-layer"));
    });
  }, []);
  return (
    <Fragment>
      <SectionTitle title="혈압/심박수 이력" style={{ marginTop: "32px" }} />

      <div className="allselect-box" style={{ padding: "0" }}>
        <div className="check-dotguide">
          <label className="check-box">
            <input type="checkbox" id="checkboxAll" onClick={checkedAll} />
            <i></i>전체선택
          </label>
          <div className="dots">
            <span>
              <i className="gre"></i>안정
            </span>
            <span>
              <i className="pin"></i>높음
            </span>
          </div>
        </div>
      </div>
      <div>
        <SectionBox
          contentsList={contentsList}
          settingSeqNo={settingSeqNo}
          openMemoPopup={openMemoPopup}
          setTargetDate={setTargetDate}
          setDisplayMod={setDisplayMod}
          setSeqNo={setSeqNo}
        />
      </div>
    </Fragment>
  );
};

const SectionBox = (props) => {
  const {
    contentsList,
    settingSeqNo,
    openMemoPopup,
    setTargetDate,
    setDisplayMod,
    setSeqNo,
  } = props;
  return (
    <div className="section-box">
      {/* <div className="date-title">{date1} {date2}</div> */}
      <SectionBoxList
        contentsList={contentsList}
        settingSeqNo={settingSeqNo}
        openMemoPopup={openMemoPopup}
        setTargetDate={setTargetDate}
        setDisplayMod={setDisplayMod}
        setSeqNo={setSeqNo}
      />
    </div>
  );
};

const SectionBoxList = (props) => {
  const {
    contentsList,
    settingSeqNo,
    openMemoPopup,
    setTargetDate,
    setDisplayMod,
    setSeqNo,
  } = props;
  const { phonecfg } = useContext(AppContext);

  const openMemoBox = (i) => {
    $(i).parent().toggleClass("on");
    $(i).next(".inthe-box").slideToggle("fast");

    if ($(i).parent().hasClass("on")) {
      var currentSctop = $(i).parent().offset().top - 20;
      $("html, body").stop().animate({ scrollTop: currentSctop }, 400);
    }

    userHabit(phonecfg, "BP100_P02");
  };
  return (
    <div className="time-schedule-list">
      {contentsList.map((m, i) => (
        <Fragment key={m.seqNo + i}>
          <div style={{ padding: "0px" }}>
            <div
              className={
                m.bpCondition == "HIGH" ? "infobox gloom" : "infobox smile"
              }
              style={{ padding: "12px" }}
            >
              <div className="data01">
                <label className="check-box">
                  <input
                    type="checkbox"
                    name="checkSeqNo"
                    value={m.seqNo}
                    onClick={settingSeqNo}
                  />
                  <i></i>
                  <span>
                    {m.date1 + "(" + m.date2 + ") " + m.date3 + m.date4}
                  </span>
                </label>
                {/* <div className="subtxt_btn" style={{display:"inlineBlock", float:"right", fontSize:"12px"}}>{m.bpcTimeNm}</div> */}
              </div>
              <a
                className="btn-dropdown"
                id={i}
                style={{ height: "60px" }}
                onClick={() => openMemoBox("#" + i)}
              >
                <i style={{ top: "16px" }}></i>
                <div>
                  {m.maxBp} <em>/</em> {m.minBp} mmhg
                  <s
                    style={{
                      display: "block",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "pretendard",
                    }}
                  >
                    심박수{" "}
                    <b>{m.hrtRate === "0" ? "미등록" : m.hrtRate + "bpm"}</b>
                  </s>
                </div>
              </a>

              <div className="inthe-box">
                {/* <div className="in-photo-area">
                                    <a className="btn-foodmenu"><img src="./images/user/user_meal_photo01.jpg" alt="" /></a>
                                </div> */}
                <p>{m.bpcMemo}</p>

                <div className="btn-right">
                  <a
                    className="btn-update"
                    onClick={() => {
                      setDisplayMod(true);
                      setTargetDate(m);
                      setSeqNo(m.seqNo);
                      document
                        .getElementsByTagName("body")[0]
                        .classList.add("scrollLock");
                    }}
                  >
                    <i></i>수정
                  </a>

                  <a
                    className="btn-memo"
                    onClick={() => openMemoPopup(m.seqNo, m.bpcMemo)}
                  >
                    <i></i>메모
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
};